// extracted by mini-css-extract-plugin
export default {"path":"_1CuDp_ZrKNI9EXlghAZu3E","object":"_3__Q_apKtqSdgBiuSllqrH","body":"_26GBuqB1ZjIQYucvuy-igA","btn":"KJWvqtAOnhZyQ1zWwuFiw","icon":"_3mBxEM8RzytusFLaZDHR21"};